module.exports = __webpack_public_path__ + "static/media/icon_exit.3458211f.svg";